import type { ShopDto } from "../generated/schema";
import { useApiMutation } from "./use-api-mutation";
import useInvalidateShop from "./use-invalidate-shop";

export default function useStripeIntegrationCreateAccountMutation(
	shop: ShopDto,
) {
	const invalidateShop = useInvalidateShop(shop.id);

	return useApiMutation<"post", "/shops/{shopId}/integrations/stripe/account", void>(
		"post",
		"/shops/{shopId}/integrations/stripe/account",
		{
			invalidate: invalidateShop,
			onSuccess: (result) => {
				window.location.replace(result.integrations.stripe.url);
			},
			mapVariables: () => ({
				params: { path: { shopId: shop.id } },
			}),
		},
	);
}
